import ColorSetting from 'app/React/Components/Form/ColorSetting'
import Setting from 'app/React/Components/Form/Setting'
import StorageLoad from 'app/React/Components/misc/StorageLoad'
import PaymentTypeSetting from 'app/React/Components/misc/PaymentTypeSetting'
import VariantSetting from 'app/React/Components/misc/VariantSetting'
import React, { useContext } from 'react'
import IsLeasing from 'app/React/Components/misc/IsLeasing'
import LeasingKmField from 'app/React/Components/Form/LeasingKmField'
import * as _ from 'remeda'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function WidgetForm(props) {
  const {
    strings
  } = useContext(ConfiguratorContext)

  const form = props.form
  const paymentStrings = strings.payment_form ?? {}
  const settings = Array.isArray(form.settings) ? { ...form.settings } : form.settings
  const setting_elements = _.pipe(
    Object.keys(settings ?? {}),
    _.sortBy((key) => settings?.[key]?.ordering),
    _.map((key) => {
      const setting = settings[key]
      if (setting.layout === 'color') {
        return <ColorSetting key={key} setting={setting}/>
      }
      return <Setting key={key} setting={setting}/>
    })
  )

  return (
    <div className='mtt-product__text-container'>
      <StorageLoad/>
      <span className='mtt-product__tagline tagline tagline--black'>Udvalgt bil</span>
      <h2 className='mtt-product__title'>{form.title}</h2>
      {props.paymenttypesetting === true ? <PaymentTypeSetting/> : null}
      {props.variantsetting === true ? <VariantSetting/> : null}
      {props.leasingkmfield === true ? (
        <IsLeasing>
          <LeasingKmField tip={paymentStrings?.leasing_range?.tip}/>
        </IsLeasing>
      ) : null}
      {setting_elements}
      {props.children}
      {typeof form.description === 'string' && form.description.length > 0 ? (
        <div className='description wysiwyg' dangerouslySetInnerHTML={{ __html: form.description }}/>
      ) : null}
    </div>
  )
}
